// removed by extract-text-webpack-plugin
module.exports = {"questionBox":"EmotionQuestion__questionBox___2JMLkKu","buttonContainer":"EmotionQuestion__buttonContainer___VNelRt6"};